export default {
	init(startDate, durationsPerNumber, formURL) {
		pp.log(
			"PhaseManager init -- startDate, durationsPerNumber, formURL",
			startDate,
			durationsPerNumber,
			formURL,
		);
		this.storedPhaseDurations = structuredClone(durationsPerNumber);
		this.startDate = new Date(startDate);
		this.storedStartDate = structuredClone(this.startDate);
		this.phaseDurations = durationsPerNumber;
		this.formURL = formURL;

		this.dataInitialized = true;
		if (this.waitingForDataInit) {
			this.setupListeners();
		}
	},

	setupListeners() {
		// pp.log("PhaseManager into setupListeners", this);
		if (!this.dataInitialized) {
			pp.log("- not initialized, setting up callback");
			this.waitingForDataInit = true;
			return;
		}

		this.waitingForDataInit = false;
		this.hydrateInputs();
		this.initStartDateDatepicker();
		this.cancelChangesTimeout = null;

		$(".PhaseManager__phase-duration-input")
			.off("input keyup")
			.on("input keyup", _.debounce(this.durationInputChanged, 100));
		// Page is Turbolinks visited after update so we only need to do `one` bindings.
		$(".j-update-phases").on("click", this.updatePhaseTimings);
		$(".j-start-phase").on("click", this.endActivePhase);
		$(".PhaseManager__phase-duration-edit-modal").on(
			"hide.bs.modal",
			pp.phaseManager.cancelChanges,
		);

		pp.gameState.observeChange(
			"phaseNumber",
			this.handlePhaseNumberChangeForPhaseManager,
		);
		pp.gameState.observeChange("endDate", this.handleEndDateChange);
		this.observeChange("startDate", this.checkActivePhaseChanged);
		this.observeChange("startDate", this.updateAllPhaseEndsAt);

		pp.gameState.observeChange("endDate", this.updateAllPhaseEndsAt);

		this.observeChange("phaseDurations", this.handlePhaseDurationsChange);
		this.observeChange("phaseDurations", this.updateAllPhaseEndsAt);
		this.handlePhaseDurationsChange(undefined, this.phaseDurations); // Trigger once now
		clearInterval(this.progressInterval); // Just in case
		this.progressInterval = setInterval(this.updateProgressBars, 333);

		$(".PhaseManager").one("destroyed destroyed_proxy", () => {
			pp.gameState.unobserveChange(
				"phaseNumber",
				this.handlePhaseNumberChangeForPhaseManager,
			);
			pp.gameState.unobserveChange("endDate", this.handleEndDateChange);
			pp.gameState.unobserveChange("endDate", this.updateAllPhaseEndsAt);

			this.unobserveChange("startDate", this.updateAllPhaseEndsAt);
			this.unobserveChange("startDate", this.checkActivePhaseChanged);
			this.unobserveChange("phaseDurations", this.handlePhaseDurationsChange);
			clearInterval(this.progressInterval);
		});

		// Trigger once now
		setTimeout(() => {
			this.handlePhaseNumberChangeForPhaseManager(
				undefined,
				pp.gameState.phaseNumber,
			);
			this.handleEndDateChange(undefined, pp.gameState.endDate);
			this.updateAllPhaseEndsAt();
		}, 300);
	},

	handlePhaseDurationsChange(oldDurationsHash, newDurationsHash) {
		pp.log(
			"PhaseManager into handlePhaseDurationsChange",
			oldDurationsHash,
			newDurationsHash,
		);
		Object.keys(newDurationsHash).forEach((phaseNumber, index) => {
			const duration = this.spellOutDurationOfPhase(phaseNumber);
			$(`.PhaseManager__phase[data-phase-number='${phaseNumber}']`)
				.find(".PhaseMananger__phase-duration")
				.text(duration);
		});
		this.hydrateInputs();

		// If no modal is open, assume that the update comes from outside (via PrivatePub)
		if (
			oldDurationsHash !== undefined &&
			!$(
				"#start-date-edit-modal.in, .PhaseManager__phase-duration-edit-modal.in",
			).length
		) {
			pp.log("- update comes from outside, overwrite `storedPhaseDurations`");
			this.storedPhaseDurations = structuredClone(newDurationsHash);
		}
	},

	// Needs another name than `handleEndDateChange` in game_state.js so that the mutation observer won't confuse the two
	handlePhaseNumberChangeForPhaseManager(oldPhaseNumber, newPhaseNumber) {
		// pp.log("PhaseManager into handlePhaseNumberChangeForPhaseManager", oldPhaseNumber, newPhaseNumber);
		$(".j-start-phase").addClass("hidden");
		pp.phaseManager.markPhaseDomElementsActive(newPhaseNumber);

		if (newPhaseNumber !== undefined && newPhaseNumber > 0) {
			// Otherwise the Game is paused or not running
			$(
				`.PhaseManager__phase[data-phase-number='${newPhaseNumber + 1}'] .j-start-phase`,
			).removeClass("hidden"); // Show the "Start now" button
		}
	},

	handleEndDateChange(oldPhaseEnd, newPhaseEnd) {
		pp.log("PhaseManager into handleEndDateChange", oldPhaseEnd, newPhaseEnd);
		const module = pp.phaseManager;
		// @ts-expect-error
		if (newPhaseEnd === undefined && pp.gameState.phaseNumber > 0) {
			$(".PhaseManager").addClass("PhaseManager--game-paused");
			$(".PhaseManager__overview-phases").addClass(
				"PhaseManager__overview-phases--game-paused",
			);
			$(".j-edit-duration, .j-start-phase, .j-edit-start-date").addClass(
				"disabled",
			);
			$(".j-edit-duration, .j-edit-start-date").attr("data-toggle", "");
		} else if (pp.gameState.phaseNumber == -1) {
			// The Game has ended
			$(".j-edit-duration, .j-edit-start-date")
				.removeClass("disabled")
				.attr("data-toggle", "modal");
		} else if (newPhaseEnd != "willBeChanged") {
			$(".PhaseManager").removeClass("PhaseManager--game-paused");
			$(".PhaseManager__overview-phases").removeClass(
				"PhaseManager__overview-phases--game-paused",
			);
			$(".j-edit-duration, .j-start-phase, .j-edit-start-date").removeClass(
				"disabled",
			);
			$(".j-edit-duration, .j-edit-start-date").attr("data-toggle", "modal");
			const newDuration =
				newPhaseEnd.getTime() / 1000 -
				// @ts-expect-error
				module.getEndDateOfPhase(pp.gameState.phaseNumber - 1);
			const clonedPhaseDurations = structuredClone(module.phaseDurations);
			// @ts-expect-error
			clonedPhaseDurations[pp.gameState.phaseNumber] = newDuration;
			module.phaseDurations = clonedPhaseDurations;
		}
	},

	calculateProgressPerc(phaseNumber) {
		// pp.log("into calculateProgressPerc -- phaseNumber", phaseNumber);
		const phaseLength = pp.phaseManager.phaseDurations[phaseNumber];
		const remaining =
			pp.phaseManager.getEndDateOfPhase(phaseNumber) -
			new Date().getTime() / 1000; // Convert to seconds
		return 100 - (remaining / phaseLength) * 100;
	},

	updateProgressBars() {
		// pp.log("into updateProgressBars");
		const phaseNumberToUse = $(".PhaseManager").hasClass(
			"PhaseManager--with-changing-active-phase",
		)
			? pp.phaseManager.getActivePhaseNumberByDurations()
			: pp.gameState.phaseNumber;
		// @ts-expect-error
		if (phaseNumberToUse === undefined || phaseNumberToUse < 1) {
			return;
		}
		const progressPerc =
			pp.phaseManager.calculateProgressPerc(phaseNumberToUse);
		// pp.log("progress percent", progressPerc);
		$(".PhaseManager__phase.PhaseManager__phase--active")
			.find(".PhaseManager__phase-progress-bar")
			.css({ height: `${progressPerc}%` });
		$(
			".PhaseManager__overview-phases:not(.PhaseManager__overview-phases--no-dynamic-update) .PhaseManager__overview-phase-progress-bar",
		).css({ width: `${progressPerc}%` });
	},

	getActivePhaseNumberByDurations() {
		const currentTime = new Date().getTime() / 1000; // Convert to seconds

		let previousEndDate;
		let currentPhaseNumber;
		let index = 0;

		// `-1` for when the Game has not started yet or already ended
		if (
			this.phaseDurations === undefined ||
			this.startDate.getTime() / 1000 > currentTime ||
			this.startDate.getTime() / 1000 +
				Object.values(this.phaseDurations).reduce((a, b) => a + b) <
				currentTime
		) {
			return -1;
		}

		while (
			!currentPhaseNumber &&
			index < Object.keys(this.phaseDurations).length
		) {
			const phaseNumber = Object.keys(this.phaseDurations)[index];
			const endDateOfPhase = this.getEndDateOfPhase(phaseNumber);
			if (
				endDateOfPhase > currentTime &&
				// @ts-expect-error
				(index == 0 || previousEndDate < currentTime)
			) {
				currentPhaseNumber = phaseNumber;
			}
			previousEndDate = endDateOfPhase;
			index++;
		}
		return currentPhaseNumber;
	},

	getEndDateOfPhase(phaseNumber) {
		let endDate = this.startDate.getTime() / 1000;
		// pp.log("get end", phaseNumber, Object.values(this.phaseDurations));
		const indexOfPhaseNumber = Object.keys(this.phaseDurations).findIndex(
			(phaseNumberInHash) => {
				return phaseNumber == phaseNumberInHash;
			},
		);
		if (indexOfPhaseNumber >= 0) {
			endDate += Object.values(this.phaseDurations)
				.slice(0, indexOfPhaseNumber + 1)
				.reduce((a, b) => a + b);
		}
		return endDate;
	},

	getRemainingTimeInActivePhase() {
		const currentTime = new Date().getTime() / 1000;
		return this.getEndDateOfPhase(pp.gameState.phaseNumber) - currentTime;
	},

	endActivePhase(event) {
		const isConcludeGameJump = $(event.currentTarget).hasClass(
			"j-conclude-game",
		);
		const confirmStatement = isConcludeGameJump
			? I18n.t("global.are_you_sure")
			: I18n.t("global.are_you_sure_with_statement", {
					statement: I18n.t("moderators_area.phase_manager.confirm_phase_jump"),
				});

		$.confirm({
			text: confirmStatement,
			confirm: function (button) {
				const module = pp.phaseManager;
				// @ts-expect-error
				const duration = module.phaseDurations[pp.gameState.phaseNumber];

				let newDuration = duration - module.getRemainingTimeInActivePhase(); // Closest minute - 60sec will make the Phase change immediate.
				newDuration = Math.round(newDuration / 60) * 60;
				if (newDuration < 60) {
					newDuration = 60;
				} else if (isConcludeGameJump) {
					newDuration += 60;
				}
				const clonedPhaseDurations = structuredClone(module.phaseDurations);
				// @ts-expect-error
				clonedPhaseDurations[pp.gameState.phaseNumber] = newDuration;
				module.phaseDurations = clonedPhaseDurations;
				module.hydrateInputs();
				module.updatePhaseTimings();
			},
			cancel: function (button) {
				pp.log("PhaseManager cancel confirm modal");
				// Just close the confirm modal
			},
		});
	},

	extendPhaseByFiveMin() {
		$.confirm({
			text: I18n.t("global.are_you_sure"),
			confirm: function (button) {
				const module = pp.phaseManager;
				const clonedPhaseDurations = structuredClone(module.phaseDurations);
				// @ts-expect-error
				clonedPhaseDurations[pp.gameState.phaseNumber] += 5 * 60; // 5 minutes
				module.phaseDurations = clonedPhaseDurations;
				module.hydrateInputs();
				module.updatePhaseTimings();
			},
			cancel: function (button) {
				pp.log("PhaseManager cancel confirm modal");
				// Just close the confirm modal
			},
		});
	},

	checkActivePhaseChanged() {
		const activePhaseNumberByDurations = this.getActivePhaseNumberByDurations();
		pp.log(
			"PhaseManager into checkActivePhaseChanged -- active Phase by durations, current Phase number",
			activePhaseNumberByDurations,
			pp.gameState.phaseNumber,
		);
		const functionToUse =
			activePhaseNumberByDurations != pp.gameState.phaseNumber
				? "addClass"
				: "removeClass";
		$(".PhaseManager")[functionToUse](
			"PhaseManager--with-changing-active-phase",
		);
		this.markPhaseDomElementsActive(activePhaseNumberByDurations);
	},

	markPhaseDomElementsActive(activePhaseNumber) {
		// Set correct active Phase in (vertical) Phase manager
		$(".PhaseManager__phase").removeClass("PhaseManager__phase--active");
		$(
			`.PhaseManager__phase[data-phase-number='${activePhaseNumber}']`,
		).addClass("PhaseManager__phase--active");
		// Set correct active Phase in (horizontal) list
		$(".PhaseManager__overview-phase").removeClass(
			"PhaseManager__overview-phase--active",
		);
		$(
			`.PhaseManager__overview-phase[data-phase-number='${activePhaseNumber}']`,
		).addClass("PhaseManager__overview-phase--active");
	},

	initStartDateDatepicker() {
		pp.phaseManager.startDateTimePickerInitialized = false;
		const _oneMinuteMs = 60 * 1000;
		const $modal = $("#start-date-edit-modal");

		// Overwrite the datetimepicker date if it's not the same as the stored `startDate` (only for when the `startDate` has been updated externally)
		$modal.off("show.bs.modal").on("show.bs.modal", () => {
			if (
				$modal
					.find("div.datetimepicker")
					.data("DateTimePicker")
					.date()
					._d.getTime() != pp.phaseManager.startDate.getTime()
			) {
				$modal
					.find(".datetimepicker")
					.data("DateTimePicker")
					.date(pp.phaseManager.startDate);
			}
		});

		$modal
			.off("hide.bs.modal")
			.on("hide.bs.modal", pp.phaseManager.cancelChanges);
		// Use the `change` event (triggered from `initDateTimePicker`) to either set the datetimepicker's date (initially on page load)
		// or update the module's `startDate`
		$modal.find(".j-datetimepicker-hidden").on("change", (event) => {
			// pp.log("change", event);
			if (!pp.phaseManager.startDateTimePickerInitialized) {
				$modal
					.find(".datetimepicker")
					.data("DateTimePicker")
					.date(pp.phaseManager.startDate);
				pp.phaseManager.startDateTimePickerInitialized = true;
			} else {
				const secondsOffset = pp.phaseManager.startDate % _oneMinuteMs;
				const newDate = $modal
					.find("div.datetimepicker")
					.data("DateTimePicker")
					.date()._d;
				// pp.log("PhaseManager updating start date:", newDate);
				pp.phaseManager.startDate = new Date(newDate.getTime() + secondsOffset);
			}
		});
	},

	cancelChanges() {
		// pp.log("PhaseManager setting timeout to cancel changes");
		const module = pp.phaseManager;
		module.cancelChangesTimeout = setTimeout(() => {
			// pp.log("in timeout");
			module.phaseDurations = structuredClone(module.storedPhaseDurations);
			module.startDate = structuredClone(module.storedStartDate);
			$("#start-date-edit-modal")
				.find(".datetimepicker")
				.data("DateTimePicker")
				.date(module.startDate);
			module.initStartDateDatepicker();
			module.hydrateInputs();
			module.updateAllPhaseEndsAt();
		}, 250);
	},

	updatePhaseTimings(event) {
		pp.log(
			"PhaseManager posting new dates -- startDate, durations",
			pp.phaseManager.startDate,
			pp.phaseManager.phaseDurations,
		);
		if ($(".j-update-phases").prop("disabled")) {
			pp.log("- returning, button is disabled");
			return;
		}
		$(".j-update-phases").addClass("disabled").prop("disabled", true);
		$.ajax({
			url: pp.phaseManager.formURL,
			type: "POST",
			dataType: "script",
			data: {
				start_date: pp.phaseManager.startDate,
				phase_durations: pp.phaseManager.phaseDurations,
			},
			success: (data) => {
				pp.log("PhaseManager updatePhaseTimings success");
				// Write the changes to the backup
				pp.phaseManager.storedPhaseDurations = structuredClone(
					pp.phaseManager.phaseDurations,
				);
				pp.phaseManager.storedStartDate = structuredClone(
					pp.phaseManager.startDate,
				);

				// Hiding the modal will call `cancelChanges` which resets the `phaseDurations`,
				// so we need to cancel the timeout (`cancelChangesTimeout`) immediately
				$(".PhaseManager").find(".modal.in").modal("hide");
				// pp.log("clearing timeout", pp.phaseManager.cancelChangesTimeout);
				clearTimeout(pp.phaseManager.cancelChangesTimeout);
				$(".j-update-phases").removeClass("disabled").prop("disabled", false);
			},
			error: (jqXHR, textStatus, errorThrown) => {
				pp.log(
					"PhaseManager updatePhaseTimings error",
					jqXHR,
					textStatus,
					errorThrown,
				);
			},
		});
	},

	durationFromInputs($durationInputEls) {
		// pp.log("PhaseManager into durationFromInputs", $durationInputEls);
		let newDurationSeconds = 0;
		_.each($durationInputEls, (input) => {
			const part = $(input).attr("data-duration-part");
			// @ts-expect-error
			newDurationSeconds += pp.phaseManager.durationPartToSeconds(
				part,
				$(input).val(),
			);
		});
		// pp.log("PhaseManager durationFromInputs: ", newDurationSeconds);
		return newDurationSeconds;
	},

	durationInputChanged(event) {
		pp.log("PhaseManager input changed", event.target);
		const module = pp.phaseManager;
		const $modal = $(event.target).closest(
			".PhaseManager__phase-duration-edit-modal",
		);
		// @ts-expect-error
		const phaseNumber = parseInt($modal.attr("data-phase-number"));
		const $inputs = $modal.find(".PhaseManager__phase-duration-input");

		let totalDurationFromInputs = module.durationFromInputs($inputs);

		// pp.log("PhaseManager durationInputChanged:", totalDurationFromInputs);
		if (totalDurationFromInputs < 60) {
			pp.log("PhaseManager durationInputChanged: resetting duration to 1 min");
			$modal
				.find(
					".PhaseManager__phase-duration-input[data-duration-part='minutes']",
				)
				.val(1);
			totalDurationFromInputs = 60;
		}

		// pp.log("PhaseManager updating phase duration:", phaseNumber, module.phaseDurations);
		const clonedPhaseDurations = structuredClone(module.phaseDurations);
		clonedPhaseDurations[phaseNumber] = totalDurationFromInputs;
		module.phaseDurations = clonedPhaseDurations;
		module.updateDurationInputs(phaseNumber);
		module.checkActivePhaseChanged();
		module.updateAllPhaseEndsAt();
	},

	updateAllPhaseEndsAt() {
		let runningPhaseDurationSum = 0;
		const module = pp.phaseManager;
		const gameStartTimeStamp =
			Math.floor(module.startDate.getTime() / 1000) * 1000;

		// pp.log("PhaseManager into updateAllPhaseEndsAt", module.startDate, module.phaseDurations);
		Object.entries(module.phaseDurations).forEach(
			([phaseNumber, phaseDuration], index) => {
				const $phaseEls = $(`[data-phase-number='${phaseNumber}']`);
				const phaseStartDateTimestamp =
					gameStartTimeStamp + runningPhaseDurationSum;
				runningPhaseDurationSum += phaseDuration * 1000; // Convert to ms
				const phaseEndDateTimestamp =
					gameStartTimeStamp + runningPhaseDurationSum;
				// @ts-expect-error
				const phaseStartDateAsString = moment(phaseStartDateTimestamp).format(
					"Y-MM-DD, HH:mm",
				); // Only used in _hoorizontal_list.html.erb
				// @ts-expect-error
				const phaseEndDateAsString = moment(phaseEndDateTimestamp).format(
					"Y-MM-DD, HH:mm",
				);

				$phaseEls.each((index, phaseEl) => {
					const $phaseEl = $(phaseEl);
					// pp.log("$phaseEl", $phaseEl);
					if ($phaseEl.attr("data-content") !== undefined) {
						// For the popover content in `_horizontal_list`
						// @ts-expect-error
						const $overlayContent = $($phaseEl.attr("data-content"));
						$overlayContent
							// @ts-expect-error
							.find(".j-phase-start-date")
							.text(phaseStartDateAsString);
						$overlayContent
							// @ts-expect-error
							.find(".j-phase-end-date")
							.text(phaseEndDateAsString);
						$phaseEl.attr("data-content", $overlayContent[0].outerHTML);
					} else {
						$phaseEl.find(".j-phase-start-date").text(phaseStartDateAsString);
						$phaseEl.find(".j-phase-end-date").text(phaseEndDateAsString);
					}
				});

				if (index == 0) {
					$(".j-game-start-date")
						.first()
						// @ts-expect-error
						.text(moment(gameStartTimeStamp).format("Y-MM-DD, HH:mm"));
				}
				// Not `else if` in case the Game only has on Phase
				if (Object.keys(pp.phaseManager.phaseDurations).length - 1 == index) {
					// The Game is paused OR the last Phase's end date is also the Game's end date
					const gameEndDateAsString =
						// @ts-expect-error
						pp.gameState.endDate === undefined && pp.gameState.phaseNumber > 0
							? "⏸"
							: phaseEndDateAsString;
					$(".j-game-end-date").first().text(gameEndDateAsString);
				}
			},
		);
	},

	durationPartToSeconds(part, val) {
		switch (part) {
			case "days":
				return val * 24 * 60 * 60;
			case "hours":
				return val * 60 * 60;
			case "minutes":
				return val * 60;
			default:
				console.error("Invalid part");
		}
	},

	updateDurationInputs(phaseNumber) {
		const $phaseEl = $(
			`.PhaseManager__phase[data-phase-number=${phaseNumber}]`,
		);
		const durationParts = pp.gameState.durationToParts(
			pp.phaseManager.phaseDurations[phaseNumber],
		);

		$phaseEl
			.find(".PhaseManager__phase-duration-input")
			.each((index, inputElem) => {
				$(inputElem).val(durationParts[index]);
			});
	},

	hydrateInputs() {
		const module = pp.phaseManager;
		// pp.log("PhaseManager hydrateInputs", module.phaseDurations);
		Object.keys(module.phaseDurations).forEach((phaseNumber, index) => {
			const durationParts = pp.gameState.durationToParts(
				module.phaseDurations[phaseNumber],
			);
			const $modalEl = $(
				`.PhaseManager__phase-duration-edit-modal[data-phase-number='${phaseNumber}']`,
			);
			$modalEl
				.find(".PhaseManager__phase-duration-input")
				.each((idx, durationInput) => {
					// Don't do anything of the values are the same
					// (avoid endless loop between ´hydrateInputs` -> `durationInputChanged` -> `handlePhaseDurationsChange` -> `hydrateInputs`)
					// @ts-expect-error
					if (parseInt(durationInput.value, 10) != durationParts[idx]) {
						$(durationInput).val(durationParts[idx]).trigger("input"); // Assume it will always be layed out [D, H, M]
					}
				});
		});
	},

	spellOutDurationOfPhase(phaseNumber) {
		// pp.log("PhaseManager into spellOutDurationOfPhase", phaseNumber, this.phaseDurations[phaseNumber]);
		const durationParts = pp.gameState.durationToParts(
			this.phaseDurations[phaseNumber],
		);

		let durationsArray = [];
		durationParts.forEach((value, index) => {
			const unit = Object.keys(pp.gameState.durationNamesAndSeconds)[index];
			durationsArray.push(
				`${value} ${I18n.t(`datetime.names.${unit}`, { count: value })}`,
			);
		});
		return durationsArray.join(" ");
	},
};
